// extracted by mini-css-extract-plugin
export default {"icon":"MonitorStatus_icon__x1Klb","content":"MonitorStatus_content__KLQBX","counter":"MonitorStatus_counter__fuVjD","text":"MonitorStatus_text__OnY+l"};